import React from 'react'
import { array } from 'prop-types'

import Grid from '../../Grid'
import Card from '../../Card'
import Surround from '../../Surround'
import Hide from '../../Hide'

const CardGrid5 = ({ articles }) => {
  if (!articles.length) return null
  const remainingArticles = articles.slice(1, -1)
  const total = articles.length
  const imageRatio = 126 / 167

  return (
    <Grid flex gutter="default">
      <Grid.Item trailingGap="mobile" width={{ d: 1 / 2 }}>
        <Surround padded="default" bordered="default">
          <Hide below="desktop">
            <Card
              typeConfig={{
                title: { size: 'heading4', themed: true }
              }}
              {...{
                ...articles[0],
                sizes: [
                  '(min-width: 1420px) 330px',
                  '(min-width: 960px) calc(25vw - 32px - 80px)',
                  'calc((100vw - 80px) * 0.5)'
                ],
                width: 330
              }}
              imageRatio={imageRatio}
            />
          </Hide>
          <Hide at="desktop">
            <Card
              typeConfig={{
                title: { size: 'heading7', themed: true }
              }}
              {...{
                ...articles[0],
                description: '',
                sizes: ['calc((100vw - 80px) * 0.5)'],
                width: 550
              }}
              imageRatio={imageRatio}
            />
          </Hide>
        </Surround>
      </Grid.Item>
      <Grid.Item width={{ d: 1 / 2 }}>
        <Grid>
          {remainingArticles.map((article, i) => {
            return (
              <Grid.Item
                hidden={i > 1 ? 'mobile' : null}
                key={i}
                trailingGap="default"
              >
                <Surround
                  padded="default"
                  bordered={i === 0 ? 'default' : 'desktop'}
                >
                  <Card
                    typeConfig={{
                      title: {
                        size: ['body2', 'heading8'],
                        weight: 'medium',
                        themed: true
                      }
                    }}
                    horizontal
                    {...{
                      ...article,
                      description: '',
                      sizes: [
                        '(min-width: 1420px) 141px',
                        '(min-width: 960px) calc(25vw - 32px - 80px)',
                        'calc(45vw - 80px)'
                      ],
                      width: 141
                    }}
                    imageRatio={imageRatio}
                  />
                </Surround>
              </Grid.Item>
            )
          })}
          <Grid.Item hidden="mobile">
            <Card
              typeConfig={{
                title: {
                  size: ['body2', 'heading8'],
                  weight: 'medium',
                  themed: true
                }
              }}
              horizontal
              {...{
                ...articles[total - 1],
                description: '',
                sizes: [
                  '(min-width: 1420px) 141px',
                  '(min-width: 960px) calc(25vw - 32px - 80px)',
                  'calc(45vw - 80px)'
                ],
                width: 141
              }}
              imageRatio={imageRatio}
            />
          </Grid.Item>
        </Grid>
      </Grid.Item>
    </Grid>
  )
}

CardGrid5.propTypes = {
  articles: array
}

export default CardGrid5
